<template>
  <b-modal
    centered
    no-close-on-backdrop
    id="objects-modal"
    cancel-variant="outline-secondary"
    :ok-title="$t('generals.save')"
    :cancel-title="$t('generals.cancel')"
    :title="$t('Список объектов')"
    @show="bindObjects"
    @hide="clearModal"
    @ok="saveClick"
  >
    <b-table :fields="fields" :items="objectsListLocal">
      <template #head()="data">
        <span>{{ $t(data.label) }}</span>
      </template>
      <template #empty>
        <div class="text-center">{{ $t('general.no_records_to_show') }}</div>
      </template>
      <template #cell(name)="{item}">
        <span>{{ item.object && item.object[$i18n.locale] }}</span>
      </template>
      <template #cell(actions)="{item}">
        <b-form-checkbox
          v-model="item.is_active"
          class="custom-control-primary"
        />
      </template>
    </b-table>
  </b-modal>
</template>

<script>
import { BModal, BTable, BFormCheckbox } from 'bootstrap-vue'
export default {
  components: {
    BModal,
    BTable,
    BFormCheckbox,
  },

  props: {
    objectsList: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

  data() {
    return {
      fields: [
        {
          key: 'object',
          label: 'Название',
        },

        {
          key: 'actions',
          label: 'Действия',
        },
      ],

      objectsListLocal: [],
    }
  },

  methods: {
    saveClick() {
      this.$emit('saveClick', this.objectsListLocal)
    },

    clearModal() {
      this.objectsListLocal = []
    },

    bindObjects() {
      this.objectsListLocal = [...this.objectsList]
    },
  },
}
</script>
